module.exports = __webpack_public_path__ + "static/logo-3e19db1e31449821057f413d1665a30c.png";